import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ProductPickerModule } from '../product-picker/product-picker.module';
import { HeroHomepageComponent } from './hero-homepage/hero-homepage.component';

@NgModule({
  exports: [HeroHomepageComponent],
  imports: [CommonModule, FontAwesomeModule, QueryParamModule, ProductPickerModule, HeroHomepageComponent],
})
export class HeroHomepageModule {}
